import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '@follosoft/react-components';

export const useRemovePaymentMethodService = (
  contractId: string | number,
  invalidateKey: unknown[],
) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string | number>({
    mutationFn: async (methodId) => {
      await axiosInstance().delete(
        `/customer/contracts/${contractId}/payment-methods/${methodId}`,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invalidateKey });
    },
  });
};
